import React from 'react';
import { Clock, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const PendingApproval = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-dark-surface border border-dark-border rounded-2xl p-8 space-y-6">
          <div className="w-16 h-16 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center mx-auto">
            <Clock className="h-8 w-8 text-amber-400" />
          </div>

          <div>
            <h1 className="text-xl font-bold text-primary mb-2">
              Compte en attente de validation
            </h1>
            <p className="text-secondary text-sm leading-relaxed">
              Merci pour votre inscription{user?.name ? `, ${user.name}` : ''} !
              Votre compte est en cours de validation par notre équipe.
              Vous recevrez une notification dès qu'il sera activé.
            </p>
          </div>

          <div className="bg-black/20 rounded-xl p-4 text-left space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-muted">Email</span>
              <span className="text-primary">{user?.email}</span>
            </div>
            {user?.company && (
              <div className="flex justify-between text-sm">
                <span className="text-muted">Entreprise</span>
                <span className="text-primary">{user.company}</span>
              </div>
            )}
            <div className="flex justify-between text-sm">
              <span className="text-muted">Statut</span>
              <span className="text-amber-400 font-medium">En attente</span>
            </div>
          </div>

          <button
            onClick={logout}
            className="flex items-center gap-2 mx-auto px-4 py-2 rounded-lg text-secondary hover:text-primary transition-colors text-sm"
          >
            <LogOut className="h-4 w-4" />
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
